import React from 'react';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import slugify from 'slugify';
import { useParams } from 'react-router';

import { OmaLummeApp } from '../../omaLummeContext';

import Loading from './Loading';
import BackButton from './BackButton';
import SidebarLiftup from '../News/SidebarLiftup';
import Box from './Box';
import AnonHeader from './AnonHeader';

// Actions.
import { fetchAlerts } from '../../actions';
// Types.
import { HubSpotBlog } from '../../types/news';
// Utils.
import { formatHubspotBody } from '../../utils/hubspot';

const Article: React.FunctionComponent = () => {
  const { users } = OmaLummeApp.useState();

  const { endpoint } = users.activeUser;
  const [alert, setAlert] = React.useState<HubSpotBlog>();
  const { t } = useTranslation();
  const { slug } = useParams<'slug'>();

  const [titleToDisplay, setTitleToDisplay] = React.useState<string>(`${t('common:general.loadingText')}`);
  const [bodyToDisplay, setBodyToDisplay] = React.useState<React.JSX.Element | undefined>(<Loading key={1} />);

  React.useEffect(() => {
    async function fetchActiveAlerts(): Promise<void> {
      setTitleToDisplay(`${t('common:general.loadingText')}…`);
      setBodyToDisplay(undefined);

      const alertRequest = await fetchAlerts();

      const alerts: HubSpotBlog[] = alertRequest.data;

      const foundAlert = alerts.find((alert) => (typeof alert?.title === 'string' ? slugify(alert?.title).toLowerCase() === slug : false));

      if (foundAlert) {
        setAlert(foundAlert);
      }
    }
    fetchActiveAlerts();
  }, [slug, t]);

  React.useEffect(() => {
    if (alert) {
      const { title, postBody, featuredImage, url } = alert;

      let image = undefined;

      if (featuredImage) {
        image = <img src={featuredImage} alt="" />;
      }

      setTitleToDisplay(title);
      setBodyToDisplay(
        <div>
          {image}
          {parse(formatHubspotBody(postBody, url))}
        </div>,
      );
    }
  }, [alert]);

  const alertContent = (
    <div aria-live="polite">
      {alert && (
        <>
          <h1 aria-live="polite">{titleToDisplay}</h1>
          {bodyToDisplay}
        </>
      )}
      {!alert && <Loading />}
    </div>
  );

  return (
    <Box wrapper size={endpoint !== 'anon' ? 'double' : 'anon'}>
      <Box size={endpoint !== 'anon' ? 'twoThirds' : 'anon'}>
        {endpoint === 'anon' && <AnonHeader />}
        <BackButton />
        {alertContent}
      </Box>

      {endpoint !== 'anon' && (
        <Box size="third">
          <SidebarLiftup />
        </Box>
      )}
    </Box>
  );
};

export default Article;
